export const GET_TOILETS = "GET_TOILETS";
export const REMOVE_TOILET = "REMOVE_TOILET";
export const ADD_TOILET = "ADD_TOILET";
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
